var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 107,
    viewBox: "0 0 117 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5380)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117 0H0V107H117V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3204 42.8252L93.1321 33.8273C94.3498 32.5861 95.1451 30.2495 96.2135 29.0189C97.2819 27.7882 95.7741 26.6194 95.7741 26.6194L91.5868 22.9841L90.9315 22.4152L86.7441 18.7799C86.7441 18.7799 85.3751 17.4512 84.3067 18.6819C83.2383 19.9125 81.0366 21.0281 79.9788 22.408L72.1809 31.39C72.1809 31.39 70.3733 32.9879 72.0035 34.4031L76.8461 38.6073C77.2457 38.9542 77.5014 39.1762 77.5014 39.1762L82.344 43.3804C83.9901 44.8095 85.3023 42.7815 85.3023 42.7815L85.3204 42.8252Z",
    fill: "#9E8959"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_5380",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 33,
    width: 53,
    height: 57
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2777 44.1394L71.1632 33.6221L31.4941 79.3152L43.6086 89.8326L83.2777 44.1394Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_5380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.4297 34.5772L80.8863 34.1054C78.2471 31.8142 74.2502 32.0962 71.9589 34.7354L37.6318 74.2754C35.3405 76.9146 35.6226 80.9115 38.2618 83.2028L38.8052 83.6745C41.4444 85.9658 45.4413 85.6837 47.7325 83.0445L82.0597 43.5045C84.3509 40.8653 84.0689 36.8684 81.4297 34.5772Z",
    strokeWidth: 1.76484,
    strokeMiterlimit: 10,
    stroke: "#05054B"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.09 25.2158L79.4746 36.2915",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4576 23.5771L76.0215 33.2943",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3482 29.5576L82.9121 39.2748",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33008 67.2377C1.33008 67.2377 14.3282 72.5966 22.3794 70.903C30.4307 69.2094 30.3328 70.5724 32.8482 69.248C35.3637 67.9236 40.8076 63.673 44.0735 63.8342C47.3395 63.9954 56.7904 62.2689 59.2003 62.3251C61.6101 62.3812 68.4626 60.7882 67.2526 56.5393C66.0426 52.2904 52.9502 52.6616 44.166 52.8774C35.3642 53.0854 32.2692 49.6836 32.2692 49.6836",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33008 67.2377C1.33008 67.2377 14.3282 72.5966 22.3794 70.903C30.4307 69.2094 30.3328 70.5724 32.8482 69.248C35.3637 67.9236 40.8076 63.673 44.0735 63.8342C47.3395 63.9954 56.7904 62.2689 59.2003 62.3251C61.6101 62.3812 68.4626 60.7882 67.2526 56.5393C66.0562 52.3382 53.2436 52.6538 44.4644 52.87L44.166 52.8774C35.3642 53.0854 32.2692 49.6836 32.2692 49.6836",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10,
    stroke: "#05054B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9883 36.8672L43.1127 41.8974C43.1127 41.8974 41.705 50.8886 43.0078 52.597",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10,
    stroke: "#05054B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1133 41.8981C43.1133 41.8981 47.6571 44.6801 51.7489 43.7786L53.9991 40.1543",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10,
    stroke: "#05054B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7695 43.7861C51.7695 43.7861 53.712 47.448 58.829 49.4546L51.7695 43.7861Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7695 43.7861C51.7695 43.7861 53.712 47.448 58.829 49.4546",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    stroke: "#05054B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8906 44.7373C42.8906 44.7373 45.2692 46.2908 46.907 46.3841C48.5449 46.4773 51.4212 47.4739 51.7078 48.251C51.9945 49.0282 51.9299 52.6935 51.9299 52.6935",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10,
    stroke: "#05054B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0757 46.0439L51.7031 48.2504",
    strokeWidth: 1.1798,
    strokeMiterlimit: 10,
    stroke: "#05054B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8478 43.9327C63.8478 43.9327 58.0904 38.1184 56.8128 36.4002C55.5353 34.682 47.684 33.0219 42.8195 32.1553C37.955 31.2886 32.7369 28.6078 31.3273 28.6153C29.9178 28.6229 19.2969 31.7639 19.2969 31.7639",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    stroke: "#05054B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.374 78.551C105.72 78.8965 106.28 78.8965 106.626 78.551L112.257 72.9198C112.602 72.5743 112.602 72.014 112.257 71.6684C111.911 71.3229 111.351 71.3229 111.005 71.6684L106 76.6739L100.995 71.6684C100.649 71.3229 100.089 71.3229 99.7431 71.6684C99.3981 72.014 99.3981 72.5742 99.7431 72.9198L105.374 78.551ZM106.626 28.0717C106.28 27.7261 105.72 27.7261 105.374 28.0717L99.7431 33.7029C99.3981 34.0484 99.3981 34.6087 99.7431 34.9542C100.089 35.2998 100.649 35.2998 100.995 34.9542L106 29.9487L111.005 34.9542C111.351 35.2998 111.911 35.2998 112.257 34.9542C112.602 34.6087 112.602 34.0484 112.257 33.7029L106.626 28.0717ZM106.885 77.9253V28.6974H105.115V77.9253H106.885Z",
    fill: "#33333F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 107,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step_1.7d784b6c8759dbfb857ff36bd6822959.svg";
export { ForwardRef as ReactComponent };